import { OrgAndIntroducerAndAdvisorFilter } from '@acre/graphql'

import request from '../requesters/search'

export const orgAndIntroducerAndAdvisorFiltersDiscovery = async () => {
  const response = await request.get<OrgAndIntroducerAndAdvisorFilter>(`/discovery/filters`)

  return response.data || null
}
